import { render, staticRenderFns } from "./DonateList.vue?vue&type=template&id=7dbca477&scoped=true"
import script from "./DonateList.vue?vue&type=script&lang=js"
export * from "./DonateList.vue?vue&type=script&lang=js"
import style0 from "./DonateList.vue?vue&type=style&index=0&id=7dbca477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbca477",
  null
  
)

export default component.exports